export function generateFormIdFromUUID(input: string) {
  return `x-${input.slice(-6)}`;
}
